module.exports = __webpack_public_path__ + "img/indexbanner.dc020eb0.png";